import React from 'react';
import './LevelProgress.css';

function LevelProgress({ summaryData, levelsData }) {
    return (
        <div className="dp-progress-card dp-neumorphic">
            <h2 className="dp-section-title">Progreso por Nivel</h2>
            <div className="dp-level-progress">
                {summaryData?.levels_progress && levelsData.length > 0 ? (
                    summaryData.levels_progress.map(levelProgress => {
                        const levelInfo = levelsData.find(l => l.level_code === levelProgress.level_code);
                        return (
                            <div className="dp-level-item" key={levelProgress.level_code}>
                                <div className="dp-level-badge">{levelProgress.level_code}</div>
                                <div className="dp-level-info">
                                    <div className="dp-level-name">{levelInfo?.title || 'Nivel'}</div>
                                    <div className="dp-progress-bar-container dp-neumorphic-inset">
                                        <div className="dp-progress-bar" style={{ width: `${Math.round(levelProgress.percentage)}%` }}></div>
                                    </div>
                                    <div className="dp-level-percentage">{Math.round(levelProgress.percentage)}% Completado</div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <p>No hay datos de progreso.</p>
                )}
            </div>
        </div>
    );
}

export default LevelProgress;